export const getAdminRequestStatus = (error) => {
  const status = Number(
    error?.status ||
      error?.response?.status ||
      error?.payload?.status ||
      error?.response?.data?.status
  );
  return Number.isFinite(status) && status > 0 ? status : null;
};

export const isAdminRequestOffline = (error) => {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  if (getAdminRequestStatus(error)) return false;
  return ["ERR_NETWORK", "ECONNABORTED", "ENETUNREACH", "ETIMEDOUT"].includes(
    String(error?.code || error?.payload?.code || "").toUpperCase()
  );
};

export const getAdminRequestState = (error) => {
  const status = getAdminRequestStatus(error);
  if (isAdminRequestOffline(error)) return "offline";
  if (status === 401) return "unauthorized";
  if (status === 403) return "forbidden";
  if (status === 404) return "notFound";
  if (status === 409) return "conflict";
  if (status >= 500) return "server";
  return "error";
};

export const toAdminRequestError = (error, fallback = "Admin request failed") => ({
  status: getAdminRequestStatus(error),
  code: error?.response?.data?.code || error?.code,
  message:
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback,
});

const defaultMessages = {
  unauthorized: "Your session has expired. Sign in again.",
  forbidden: "You are not allowed to perform this action.",
  notFound: "The requested record was not found.",
  conflict: "This action conflicts with current data. Refresh and try again.",
  offline: "The service is unavailable offline. Check your connection and try again.",
  server: "The service could not complete the request. Try again later.",
  fallback: "The request could not be completed.",
};

export const getAdminRequestMessage = (error, options = {}) => {
  const state = getAdminRequestState(error);
  const key = state === "error" ? "fallback" : state;
  if (options[key] !== undefined) return options[key];
  return typeof options.t === "function"
    ? options.t(`AdminRequestError.${key}`, { defaultValue: defaultMessages[key] })
    : defaultMessages[key];
};
